<template>
    <div id="competition_form" :class="componentName === 'FilmCompany' ? 'film_company_component' : ''"
         v-if="!isLoading">
        <SaveInfo
                :isDataUpdating="isDataUpdating"
        ></SaveInfo>

        <Form ref="clientForm" id="competition_form" v-slot="{errors}">
            <template>
                <Field style="display: none" v-model="user.firmName" name="firmName"
                       :rules="isRequired"></Field>

                <Field style="display: none" v-model="user.userData.full_yur_name" name="full_yur_name"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.speciality" name="speciality"
                       :rules="isRequired"></Field>
                <!--                <Field style="display: none" v-model="user.userData.short_name" name="short_name"-->
                <!--                       :rules="isRequired"></Field>-->
                <Field style="display: none" v-model="user.userData.phone" name="phone"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.userData.email" name="email"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.userData.address" name="address"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.userData.contact_person" name="contact_person"
                       :rules="isRequired"></Field>

<!--                <Field style="display: none" v-model="user.userData.presentation" name="presentation"-->
<!--                       :rules="isRequired"></Field>-->

                <Field style="display: none" v-model="user.userData.create_year" name="create_year"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.logo" name="logo"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.firstName" name="firstName"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.lastName" name="lastName"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.patronymic" name="patronymic"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.about" name="about"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.avatar" name="avatar"
                       :rules="isRequired"></Field>

                <Field style="display: none" v-model="user.country" name="country"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.region" name="region"
                       :rules="isRequired"></Field>
                <Field style="display: none" v-model="user.city" name="city"
                       :rules="isRequired"></Field>



                <Field style="display: none" name="hasPublishedFilmOrPractic" :rules="hasPublishedFilmOrPractic"></Field>
										<!--                <Field style="display: none" v-model="films" name="films"-->
<!--                       :rules="isRequired"></Field>-->


            </template>

            <div class="content_block_top_label">
                <p v-if="selectedCompetitionItem?.name">Текущий выбранный конкурс: <strong>{{
										selectedCompetitionItem.name
                    }}</strong>
                </p>
                <p v-if="selectedCompetitionItem?.name" style="margin: 30px 0;"><a class="button4"
                                                                               @click.prevent="showModal">Подать заявку
                    на конкурс</a></p>
                <p v-else style="margin: 30px 0;"><a class="button4"
                                                     @click.prevent="showModal">Перейти
                    к отправке на конкурсы</a></p>
                <p style="margin-bottom: 30px">Чтобы подать проект на конкурс пройдите в раздел нужного вам конкурса и
                    нажмите
                    "Подать заявку"</p>
            </div>


            <div class="errors-block"
                 v-if="Object.keys(errors).length > 0">
                <b>Пожалуйста, заполните поля:</b>
                <ul>
                    <li v-for="(error,index) in errors" :key="index">Поле "{{ getFieldNameByIndex(index) }}"
                        обязательно для заполнения
                    </li>
                </ul>
            </div>

            <div class="columns column2block">
                <div class="column gray_box gray_box__filled">

                    <p class="req">Краткое наименование компании</p>
                    <Input
                            v-model:value="user.firmName"
                            @blur="saveData"
                    />

                    <div class="field">
                        <p class="req">Полное юридическое наименование организации</p>
                        <Input
                                v-model:value="user.userData.full_yur_name"
                                @blur="saveData"
                        />
                    </div>

                    <BaseChoiseSelect
                            label="Тип компании"
                            v-model="user.speciality"
                            :is-required="true"
                            :values="[
                                {
                                  'value': 'Частная',
                                  'label': 'Частная'
                                },
                                {
                                  'value': 'Государственная',
                                  'label': 'Государственная'
                                }
															]"
                            @onChange="saveData"
                    ></BaseChoiseSelect>

                    <BaseLocation
                            v-model:country="user.country"
                            v-model:city="user.region"
                            v-model:region="user.city"
                            :is-city-required="true"
                            :is-country-required="true"
                            :is-region-required="true"
                            @onChange="saveData"
                    ></BaseLocation>

                    <div class="field">
                        <p class="req">Телефон</p>
                        <Input
                                v-model:value="user.userData.phone"
                                @blur="saveData"
                        />
                    </div>

                    <div class="field">
                        <p>Сайт</p>
                        <Input
                                v-model:value="user.userData.sait"
                                @blur="saveData"
                        />
                    </div>

                    <div class="field">
                        <p class="req">Адрес электронной почты</p>
                        <Input
                                v-model:value="user.userData.email"
                                @blur="saveData"
                        />
                    </div>

                    <div class="field">
                        <p class="req">Адрес местонахождения организации</p>
                        <Input
                                v-model:value="user.userData.address"
                                @blur="saveData"
                        />
                    </div>

                    <div class="field">
                        <p class="req">Контактное лицо</p>
                        <Input
                                v-model:value="user.userData.contact_person"
                                @blur="saveData"
                        />
                    </div>

                    <div class="field">
                        <p class="req">Год создания компании</p>
                        <DatePicker
                                picker="year"
                                placeholder="Выберите год"
                                format="YYYY"
                                valueFormat="YYYY"
                                @change="saveData"
                                v-model:value="user.userData.create_year"
                        ></DatePicker>
                    </div>

                    <div class="field">
                        <BaseGeneralPdfUploader
                                label="Презентация о студии"
                                object-key="user"
																:is-new-link="true"
                                v-model="user.userData.presentation"
                                @onChange="saveData"
                        ></BaseGeneralPdfUploader>
                    </div>


                </div>
                <div class="column is-narrow gray_box gray_box__bordered" style="padding: 20px">
                    <p class="gray_box__title req" style="text-align: center">Логотип компании</p>
                    <p style="font-size: 14px;">Рекомендуемая ширина изображения от 1000 пикселей</p>
                    <div class="logo_wrapper">
                        <ImageUpload
                                :image-name="user.logo"
                                :image-path="'/uploads/images/user/'"
                                :is-data-updating="isDataUpdating"
                                :entity-id="user.id"
                                @save-image="setUserLogo"
                        ></ImageUpload>
                    </div>

                    <div class="field">
                        <label for="user_edit_plainPassword">Пароль (оставьте пустым, если не требуется изменение)</label>
                        <input type="text" id="user_edit_plainPassword" name="user_edit[plainPassword]" v-model="newPassword">

                        <button style="margin-top: 20px;" class="button2" @click.prevent="saveNewPassword">Сохранить пароль</button>
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column block2">

                    <div class="columns block2__inner">
                        <div style="" class="column gray_box__filled boss_data">
                            <p class="gray_box__title">ДАННЫЕ О РУКОВОДИТЕЛЕ</p>
                            <div class="field">
                                <p class="req">Фамилия руководителя киностудии</p>
                                <Input
                                        v-model:value="user.firstName"
                                        @blur="saveData"
                                />
                            </div>

                            <div class="field">
                                <p class="req">Имя руководителя киностудии</p>
                                <Input
                                        v-model:value="user.lastName"
                                        @blur="saveData"
                                />
                            </div>

                            <div class="field">
                                <p class="req">Отчество руководителя киностудии</p>
                                <Input
                                        v-model:value="user.patronymic"
                                        @blur="saveData"
                                />
                            </div>

                            <div class="field">
                                <p class="req">Информация о руководителе (опыт)</p>
                                <Textarea
                                        v-model:value="user.about"
                                        @blur="saveData"
                                ></Textarea>

                            </div>
                        </div>
                        <div class="column gray_box__bordered" >
                            <p class="gray_box__title req" style="text-align: center">Фото руководителя</p>
                            <p style="font-size: 14px;">Рекомендуемая ширина изображения от 500 пикселей</p>
                            <div class="avatar_wrapper">
                                <ImageUpload
                                        :image-name="user.avatar"
                                        image-path="/uploads/images/"
                                        :is-data-updating="isDataUpdating"
                                        :entity-id="user.id"
                                        :aspect-ratio="500 / 500"
                                        @save-image="setUserAvatar"
                                ></ImageUpload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns" style="margin-top: 15px;">
                <div class="column" style="padding: 0">
                    <div class="header_title2">Фильмы компании</div>

                    <div class="film_type_selector">
                        <div class="film_type_selector_item" @click="film_selector_tab = 1"
                             :class="film_selector_tab === 1 ? 'is_active' : ''">
                            <span>Все проекты</span>
                        </div>
                        <div class="film_type_selector_item" @click="film_selector_tab = 2"
                             :class="film_selector_tab === 2 ? 'is_active' : ''">
                            <span>Реализованные</span>
                        </div>
                        <div class="film_type_selector_item" @click="film_selector_tab = 3"
                             :class="film_selector_tab === 3 ? 'is_active' : ''">
                            <span>В производстве</span>
                        </div>
                    </div>

                    <div class="button4_wrapper">
                        <a class="button4" href="/project/film">Добавить фильм</a>
                    </div>

                    <FilmsRenderComponent
                            :films="film_filtered"
                            :isShowActionsBlock="true"
														@update="getFilms"
                    ></FilmsRenderComponent>


                    <!--                <h3>Наши лучшие практики</h3>-->
                    <!--                <Space wrap>-->
                    <!--                    <Button href="/project/films">Посмотреть все</Button>-->
                    <!--                    <Button href="/project/film">Добавить новый фильм</Button>-->
                    <!--                    <Button href="/project/other_practices">Добавить другие практики</Button>-->
                    <!--								</Space>-->


                    <div class="header_title2">Другие практики</div>

                    <div class="film_type_selector">
                        <div class="film_type_selector_item" @click="practic_selector_tab = 1"
                             :class="practic_selector_tab === 1 ? 'is_active' : ''">
                            <span>Все проекты</span>
                        </div>
                        <div class="film_type_selector_item" @click="practic_selector_tab = 2"
                             :class="practic_selector_tab === 2 ? 'is_active' : ''">
                            <span>Реализованные</span>
                        </div>
                        <div class="film_type_selector_item" @click="practic_selector_tab = 3"
                             :class="practic_selector_tab === 3 ? 'is_active' : ''">
                            <span>В производстве</span>
                        </div>
                    </div>

                    <div class="button4_wrapper">
                        <a class="button4" href="/project/other_practices">Добавить практику</a>
                    </div>

                    <PracticsRenderComponent
                            :practices="practic_filtered"
                            :isShowActionsBlock="true"
                            @update="getPractices"
                    ></PracticsRenderComponent>


                </div>
            </div>

            <a-modal
                    v-model:visible="isShow"
                    :footer="null"
                    width="70%"
                    :destroyOnClose="true"
                    :style="{ 'max-width': '1000px' }"
            >
                <CompetitionSelectComponent
                        :competition-mode="competitionMode"
                        :competitions="competitions"
                        :totalCompetitions="totalCompetitions"
                        :is-loading="isLoading"
                        @loadCompetitions="loadCompetitions"
                        @close="isShow = false"
                        :errors="getErrors(errors)"
												type="user"
												:entity-id="user.id"
                >
                </CompetitionSelectComponent>
            </a-modal>
        </Form>
    </div>
    <div v-else>
        <div style="text-align: center;">
            <Spin></Spin>
        </div>
    </div>
</template>
<script>

export default {
  name: "FilmCompany",

  data() {
    return {
      componentName: this.$options.name // Используем $options.name для получения имени компонента
    };
  }
};
</script>
<script setup>
import {computed, ref, watch} from "vue";
import {Input, Textarea, Spin, DatePicker, Modal} from "ant-design-vue"
import BaseLocation from "@/components/Base/BaseLocationCountryRegionCity.vue";
import axios from "axios";
import SaveInfo from "@/components/Base/SaveInfo.vue";
import Json from '@/services/json'
import 'cropperjs/dist/cropper.css';
import BaseChoiseSelect from "@/components/Base/BaseChoiseSelect.vue";
import ImageUpload from "@/components/Base/ImageUpload.vue";
import FilmsRenderComponent from "@/components/Base/FilmsRenderComponent.vue";
import PracticsRenderComponent from "@/components/Base/PracticsRenderComponent.vue";
import BaseGeneralPdfUploader from "@/components/Base/BaseGeneralPdfUploader.vue"
import {Field, Form} from 'vee-validate';
import CompetitionSelectComponent from "@/components/Components/CompetitionSelectComponent.vue";
import { useCompetitionToProjectInfo } from "@/stores/competitionToProjectInfo";
import ImageService from "@/services/ImageService";
const store = useCompetitionToProjectInfo();

const AModal = Modal;

let user = ref({
  id: '',
  avatar: '',
  about: '',
  logo: '',
  firmName: '',
  email: '',
  country: '',
  region: '',
  city: '',
  phone: '',
  firstName: '',
  lastName: '',
  patronymic: '',
  speciality: '',
  userData: {
    short_name: '',
    create_year: '',
    presentation: '',
    full_yur_name: '',
    phone: '',
    sait: '',
    email: '',
    address: '',
    contact_person: '',
    is_publish: false
  }
});
let isDataUpdating = ref(false);

let isShow = ref(false);
let isLoading = ref(false);
let isSubmited = ref(false);
let film_selector_tab = ref(1);
let practic_selector_tab = ref(1);

let competitions = ref([]);
let totalCompetitions = ref(0);
let selectedCompetition = ref({});

let newPassword = ref('');


async function getData() {
  isLoading.value = true;
  const response = await axios.get('/api/users/' + window.userid + '.json');
  response.data = Json.replaceKeys(response.data);
  response.data.userData = Json.handle_json_field(response.data.userData, user.value.userData);
  user.value = response.data;

  await loadCompetitions(1)

  isLoading.value = false;
}

getData();

async function saveData() {
  isDataUpdating.value = true;

  // let is_valid = true;
  // if (user.value?.userData?.is_publish) {
  //   is_valid = await validate();
  // }

  const object = structuredClone(user.value);

  delete object.avatar;
  delete object.logo;

  const response = await axios.patch('/api/users/' + window.userid, object, {
    headers: {
      'Content-Type': "application/merge-patch+json"
    }
  }).catch((event) => {
    alert(event.response.data['hydra:description']);
  })

  user.value = Json.replaceKeys(response.data);
  isDataUpdating.value = false;
  // if (!is_valid) {
  //   getData();
  // }
}


async function setUserLogo(formData) {
  await axios(
    {
      method: 'post',
      url: '/setUserLogo',
      data: formData
    }
  );
  getData();
}

async function setUserAvatar(formData) {
  await axios(
    {
      method: 'post',
      url: '/setUserAvatar',
      data: formData
    }
  );
  getData();
}


let films = ref([]);

async function getFilms() {
  const response = await axios.post('/project/getUserFilms', null, {
    params: {
      userId: window.userid
    }
  })
  films.value = response.data;
}

getFilms();


let practices = ref([]);

async function getPractices() {
  const response = await axios.post('/project/getUserPractices', null, {
    params: {
      userId: window.userid
    }
  })
  practices.value = response.data;
}

getPractices();


function isRequired(value) {
  if (isSubmited.value === false) {
    return true;
  }
  if (value === null) {
    return false;
  }
  if (Array.isArray(value)) {
    return value && value.length > 0;
  } else {
    return value && value.trim().length > 0;
  }
}

function hasPublishedFilmOrPractic() {
  let res = false;

  films.value.forEach((film)=>{
    if (film.isPublished) {
      res = true;
		}
	});

  practices.value.forEach((item)=>{
    if (item.isPublished) {
      res = true;
    }
  });

  return res;
}

async function saveNewPassword() {
  await axios.post('/change_profile_password', null, {params: {plainPassword: newPassword.value}});
  newPassword.value = '';
  alert('Сохранено');
}


function getFieldNameByIndex(index) {
  let res = '';
  if (index === 'full_yur_name') {
    res = 'Полное юридическое наименование организации';
  } else if (index === 'firmName') {
    res = 'Краткое наименование компании';
  } else if (index === 'speciality') {
    res = 'Тип компании';
  }
    // else if (index === 'short_name') {
    //   res = 'Краткое наименование организации';
  // }
  else if (index === 'phone') {
    res = 'Телефон';
  } else if (index === 'email') {
    res = 'Адрес электронной почты';
  } else if (index === 'address') {
    res = 'Адрес местонахождения организации';
  } else if (index === 'contact_person') {
    res = 'Контактное лицо';
  } else if (index === 'create_year') {
    res = 'Год создания компании';
  } else if (index === 'logo') {
    res = 'Логотип компании';
  } else if (index === 'firstName') {
    res = 'Фамилия руководителя киностудии';
  } else if (index === 'lastName') {
    res = 'Имя руководителя киностудии';
  } else if (index === 'patronymic') {
    res = 'Отчество руководителя киностудии';
  } else if (index === 'about') {
    res = 'Информация о руководителе (опыт)';
  } else if (index === 'avatar') {
    res = 'Фото руководителя';
  } else if (index === 'country') {
    res = 'Страна';
  } else if (index === 'region') {
    res = 'Регион';
  } else if (index === 'city') {
    res = 'Город';
  } else if (index === 'hasPublishedFilmOrPractic') {
    res = 'Нужно добавить хотя бы одну опубликованную практику или фильм';
  }

  // else if (index === 'presentation') {
  //   res = 'Презентация о студии';
  // }
  return res;
}

const clientForm = ref(null);

async function checkErrors() {
  isSubmited.value = true;
  const valid = await clientForm.value.validate();
  let is_valid = false;
  if (valid.errors && Object.keys(valid.errors).length > 0) {
    if (user.value?.userData?.is_publish) {
      user.value.userData.is_publish = false;
    } else {
      if (document.getElementById("competition_form")) {
        document.getElementById("competition_form").scrollIntoView();
      }
    }
  } else {
    is_valid = true;
    user.value.userData.is_publish = true;
  }
  return is_valid;
}

watch(() => store.selectedCompetition, (newValue, oldValue) => {
	checkErrors();
})

// async function publish() {
//   const is_valid = await checkErrors();
//   if (is_valid) {
//     saveData();
//     getData();
// 	}
// }

const film_filtered = computed(() => {
  if (film_selector_tab.value === 1) {
    return films.value;
  }
  if (film_selector_tab.value === 2) {
    return films.value.filter((item) => {
      return item.project_data?.status === 'Реализован';
    });
  }
  if (film_selector_tab.value === 3) {
    return films.value.filter((item) => {
      return item.project_data?.status === 'В производстве';
    });
  }
  return [];
})

const practic_filtered = computed(() => {
  if (practic_selector_tab.value === 1) {
    return practices.value;
  }
  if (practic_selector_tab.value === 2) {
    return practices.value.filter((item) => {
      return item.project_data?.status === 'Реализована';
    });
  }
  if (practic_selector_tab.value === 3) {
    return practices.value.filter((item) => {
      return item.project_data?.status === 'В производстве';
    });
  }
  return [];
})

async function loadCompetitions(pageNum) {

  //this.isLoading = true;

  let url = '/competition/apiGetPloshadkaCompetitions/' + user.value.id + '/' + pageNum;

  if (pageNum === 0) {
    url = '/competition/apiGetPloshadkaCompetitions/' + user.value.id
  }

  const response = await axios.get(url, {
    headers: {
      'Accept': 'application/ld+json',
    }
  });

  competitions.value = response.data['competitions'];
  totalCompetitions.value = response.data['total'];
  //this.isLoading = false;
}

let competitionMode = ref(true);

function showModal() {
  // if (window.new.length > 0) {
  //   checkErrors()
  // }
  isShow.value = true;
}

const selectedCompetitionItem = computed(() => {
  return store.selectedCompetition ?? {};
})

function getErrors(errors) {
  let res = [];
  if (typeof errors === 'object' && Object.keys(errors).length > 0) {
    Object.keys(errors).forEach((error)=>{
      res.push({'text': getFieldNameByIndex(error)})
    })
	}
	return res;
}

</script>

<style scoped>
.gray_box {
    max-width: 805px;
}
.content_block_top_label {
    margin-left: -10px;
    margin-right: -10px;
}
.button4_wrapper {
    margin-top: 20px;
}

.logo_wrapper:deep img {
    border-radius: 20px;
    width: 278px;
}
.boss_data {
		margin-right: 20px;
}

.logo_wrapper:deep label {
    text-align: center;
}

.avatar_wrapper:deep label {
    text-align: center;
}

.avatar_wrapper:deep img {
    border-radius: 200px;
    width: 200px;
    margin: auto;
}

.avatar_wrapper:deep .image__wrapper, .logo_wrapper:deep .image__wrapper {
    text-align: center;
}

.block2 {
    max-width: 875px;
}

.block2__inner {
    align-items: baseline;
}

.film_company_component .back_link {
    padding-left: 0;
}

.button_column {
    text-align: right;
    padding-right: 0;
    padding-bottom: 20px;
}


.film_type_selector {
    display: flex;
    margin-top: 20px;
    font-size: 15px;
    color: #1D232D;
}

.film_type_selector .film_type_selector_item:not(:last-child) {
    margin-right: 10px;
}

.film_type_selector_item {
    cursor: pointer;
}

.film_type_selector_item.is_active {
    font-weight: 500;
    box-shadow: inset 0 0 32px 0 rgba(255, 255, 255, 0.16);
}

.film_type_selector_item.is_active span {
    border-bottom: 3px solid;
    display: inline-block;
    padding-bottom: 7px;
    border-image: linear-gradient(135deg, #f7c100 0.01%, #f69400 100%);
    border-image-slice: 1;
}

@media (max-width: 1000px) {
    .button_column {
        text-align: left;
    }

    .film_type_selector {
        flex-direction: column;
    }

    .film_type_selector_item {
        margin-bottom: 10px;
        flex-grow: 0;
    }
    .boss_data {
        margin-right: 0;
    }
}
</style>